import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalTitle,
  ModalDescription,
  ModalQuestionConfirm,
  ModalSpanDescription,
  ModalButtonsContainer,
  ModalCancelButton,
  ModalConfirmButton,
} from "./styles";

export default function CustomModalConfirmation({
  show,
  intl,
  title = "Confirmation",
  description = "",
  questionConfirm = "",
  handleClose,
  handleConfirm,
  confirmText = "confirm",
  cancelText = "goback",
  IconConfirm = null,
  IconCancel = null,
  loading = false,
  bgConfirm = undefined,
  bgCancel = undefined,
  textColorConfirm = undefined,
  textColorCancel = undefined,
}) {
  if (!show) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          {title && <ModalTitle>{title}</ModalTitle>}

          {description && <ModalDescription>{description}</ModalDescription>}

          {questionConfirm && (
            <ModalQuestionConfirm>{questionConfirm}</ModalQuestionConfirm>
          )}

          <ModalButtonsContainer>
            <ModalCancelButton
              disabled={loading}
              type="button"
              onClick={handleClose}
              background={bgCancel}
              color={textColorCancel}
            >
              {IconCancel && <IconCancel />}
              <span>{intl.formatMessage({ id: cancelText })}</span>
            </ModalCancelButton>

            <ModalConfirmButton
              disabled={loading}
              type="button"
              onClick={handleConfirm}
              background={bgConfirm}
              color={textColorConfirm}
            >
              {IconConfirm && <IconConfirm />}
              <span>{intl.formatMessage({ id: confirmText })}</span>
            </ModalConfirmButton>
          </ModalButtonsContainer>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
}
